// utils/estado.js
//
// El back calcula el estado de cada turno y lo manda en horarios[N].estado.
// El front solo mapea la letra al color y label correspondiente.
//
// Códigos posibles:
//   B → Sin novedad (no es su hora todavía, no llegó aún)
//   V → A tiempo (llegó antes o exactamente en su hora)
//   A → Demorado (llegó pasada su hora)
//   R → Falta (no llegó y ya pasó su hora)

export const ESTADO_COLORS = {
    V: "#4caf50",       // verde
    A: "#ffc400",       // amarillo
    R: "#f44336",       // rojo
    B: "transparent",   // sin relleno (borde gris en EstadoCell)
};

export const ESTADO_LABEL = {
    V: "A tiempo",
    A: "Demorado",
    R: "Falta",
    B: "Sin novedad",
};

/**
 * Mapea los horarios del back a un array de estados para la celda Estado.
 * No hace ningún cálculo — el back ya determinó el estado de cada turno.
 *
 * @param {Array} horarios - Array de objetos { estado, entrada, salida } del back.
 * @returns {Array<{ turno: number, horario: string, estado: string }>}
 */
export function calcularEstadoColumna(horarios, eventos) {
    const tieneEventos = Array.isArray(eventos) && eventos.length > 0;

    if (!tieneEventos) {
        // Sin eventos → usar el estado que manda el back en el horario
        const estadoHorario = horarios?.find(h => h.estado)?.estado;
        if (!estadoHorario || estadoHorario === "B") return []; // blanca (circle gris)
        return [{ turno: 1, horario: "", estado: estadoHorario }]; // R o lo que sea
    }

    // Con eventos → usar el estado del último evento
    // TODO: reemplazar por eventos[0]?.gateESHistoSemaforo cuando llegue del back
    const estadoDelBack = horarios?.find(h => h.estado && h.estado !== "B")?.estado;
    const estado = eventos[0]?.gateESHistoSemaforo ?? estadoDelBack ?? "B";

    return [{ turno: 1, horario: "", estado }];
}
